import { render, staticRenderFns } from "./sponsorship_ceremonies.vue?vue&type=template&id=58c9c838&"
import script from "./sponsorship_ceremonies.vue?vue&type=script&lang=js&"
export * from "./sponsorship_ceremonies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports